import { mdiAccount, mdiCheckCircle, mdiEmail, mdiPhone } from "@mdi/js";
import Icon from "@mdi/react";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useModal } from "../../../../../../context_providers/modal/modal_context";
import { useOrderCreateCtx } from "../../../../../../context_providers/order_create_context";
import {
  useToast,
  ToastType,
} from "../../../../../../context_providers/toast/toast_ctx";
import { GetUsersRepo } from "../../../../../../service/repos/customer/customer_repo";
import debounce from "lodash.debounce";
import { CustomerDetailModel } from "../../../../../../service/models/orders/customer_detail_model";
import UserSearchFieldV2 from "./user_search_widgetV2";
interface CustomerWidgetProps {}

const CustomerWidget: FunctionComponent<CustomerWidgetProps> = () => {
  const { showToast } = useToast();
  const { setLoading } = useModal();
  const {
    order,
    setOrder,
    user,
    setUser,
    lastOrder,
    selectLastOrder,
    prefilled,
    setPrefilled,
  } = useOrderCreateCtx();

  const [search, setSearch] = useState("");

  const [suggestions, setSuggestions] = useState<
    {
      label: string;
      value: any;
    }[]
  >();

  const getUsers = async (query: string) => {
    setLoading(true);
    const res = await GetUsersRepo({
      search: query,
      all: true,
    });
    if (res.success) {
      setSuggestions(
        res.data.data.map(
          (cust: {
            uid: number;
            first_name: string;
            last_name: string;
            mobile?: string;
            email?: string;
          }) => ({
            label: `${cust.first_name} ${cust.last_name} (${cust.mobile})`,
            value: cust,
          }),
        ),
      );
    } else {
      showToast({ type: ToastType.error, text: res.error });
    }
    setLoading(false);
  };

  const debouncedHandler = useCallback(
    debounce((query) => {
      if (query) getUsers(query);
      else setSuggestions(undefined);
    }, 500),
    [],
  );

  useEffect(() => {
    debouncedHandler(search);
  }, [search]);
  return (
    <>
      <div className="text-sm md:ml-12">
        <div className="flex flex-col justify-between ">
          <div className={`w-full md:w-96`}>
            {" "}
            <UserSearchFieldV2
              id="order-create-customer-search"
              value={user as any}
              placeholder="Search customer"
              onSelect={function (data: CustomerDetailModel): void {
                console.log("Customer Data", data);
                setOrder({
                  ...order,
                  customer: data,
                  segment: data.additional_customer_details?.lead_segment ?? "",
                  sales_person_id:
                    data.additional_customer_details?.sales_person_uid,
                  sales_person_name:
                    data.additional_customer_details?.sales_person ?? "",
                  rm_uid: data.additional_customer_details?.rm_uid,
                  rm_name:
                    data.additional_customer_details?.relationship_manager ??
                    "",
                  dealer_code: data.additional_customer_details?.dealer_code,
                });
                setUser(data as any);
              }}
            />
          </div>

          <p className="italic text-xs text-gray-400">
            Please search customer and select from suggestions.
          </p>
        </div>
        {user && (
          <>
            <hr className="my-3" />
            <div className="py-2">
              <div className="flex gap-1">
                <Icon
                  path={mdiAccount}
                  className="h-4 w-4 text-gray-500"
                ></Icon>
                <p id="order-create-customer-name">
                  <b>
                    {user.first_name} {user.last_name}
                  </b>
                </p>
              </div>
              <div className="flex gap-1">
                <Icon path={mdiPhone} className="h-4 w-4 text-gray-500"></Icon>

                <p id="order-create-customer-mobile">{user.mobile}</p>
              </div>
              <div className="flex gap-1">
                <Icon path={mdiEmail} className="h-4 w-4 text-gray-500"></Icon>
                <p id="order-create-customer-email">{user.email}</p>
              </div>
            </div>
            <hr />
            <div className="text-sm">
              Last Order : {"  "}
              <Link
                id="order-create-last-order-link"
                target="_blank"
                to={`orders/${lastOrder?.order_id}`}
                className="text-blue-400"
              >
                {lastOrder?.order_id}
              </Link>
              <div className=" flex gap-2 items-center">
                <p> Do you want to pre fill order details from last order ?</p>
                {!prefilled ? (
                  <button
                    id="order-create-prefill-last-order-btn"
                    className="bg-teal text-white shadow rounded px-5 py-1"
                    onClick={() => {
                      selectLastOrder();
                      setPrefilled(true);
                    }}
                  >
                    Yes
                  </button>
                ) : (
                  <div
                    id="order-create-prefill-done"
                    className="flex gap-1 text-green-400"
                  >
                    Done{" "}
                    <Icon path={mdiCheckCircle} className="w-4 h-4 "></Icon>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CustomerWidget;
